import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import TrendingFinds from "./components/TrendingFinds";
import SEOContent from "./components/SEOContent";
import CTASection from "./components/CTASection";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://gtbuy.my";

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "GTBuy Sheet",
            "url": siteUrl,
            "description": "Compare spreadsheet deals across GTBuy, Kakobuy, and Superbuy. Find the best prices on shoes, hoodies, jackets, bags, and more across 14 product categories.",
            "potentialAction": {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": `${siteUrl}/search?q={search_term_string}`,
              },
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "GTBuy Sheet",
            "url": siteUrl,
            "description": "GTBuy Sheet helps shoppers compare prices across GTBuy, Kakobuy, and Superbuy with curated spreadsheet data updated daily.",
            "sameAs": [
              "https://kaspreadsheet.com",
            ],
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <TrendingFinds />
        <SEOContent />
        <CTASection />
        <Testimonials />
      </main>
      <Footer />
    </>
  );
}